import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Person_Amozesh_Interface, Person_Amozesh_Interface } from 'src/app/Interface/Person_Amozesh_Interface';
import { Empty_Person_Document_Interface, Person_Document_Interface } from 'src/app/Interface/Person_Document_Interface';
import { Empty_Person_Interface, Person_Interface } from 'src/app/Interface/Person_Interface';
import { Person_Kari_Interface,Empty_Person_Kari_Interface } from 'src/app/Interface/Person_Kari_Interface';
import { Empty_Person_Skill_Interface, Person_Skill_Interface } from 'src/app/Interface/Person_Skill_Interface';
import { Empty_Person_Tahghigh_Interface, Person_Tahghigh_Interface } from 'src/app/Interface/Person_Tahghigh_Interface';
import { Empty_Person_Tahsili_Interface, Person_Tahsili_Interface } from 'src/app/Interface/Person_Tahsili_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DocumentGroupService } from 'src/app/Service/DocumentGroup/DocumentGroup.service';
import { DocumentTitleService } from 'src/app/Service/DocumentTitle/DocumentTitle.service';
import { DorehAmoozeshiService } from 'src/app/Service/DorehAmoozeshi/DorehAmoozeshi.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PersonService } from 'src/app/Service/Person/Person.service';
import { ProvinceService } from 'src/app/Service/Province/Province.service';
import { SarFaslAmozeshiService } from 'src/app/Service/SarFaslAmozeshi/SarFaslAmozeshi.service';
import { SematService } from 'src/app/Service/Semat/Semat.service';
import { SkillService } from 'src/app/Service/Skill/Skill.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-PersonAdd',
  templateUrl: './PersonAdd.component.html',
  styleUrls: ['./PersonAdd.component.scss']
})
export class PersonAddComponent implements OnInit {
  Add_Record_Persone:Person_Interface=Empty_Person_Interface()
  BaseUrl=environment.BaseUrl

  constructor(
    private Person_Service:PersonService,
    private Nav_Service:NavService,
    private province_Service:ProvinceService,
    private Alertify_Service:AlertifyService,
    private Semat_Service:SematService,
    private modalService: BsModalService,


    private DocumentTitle_Service:DocumentTitleService,
    private DocumentGroup_Service:DocumentGroupService,
    private SarFaslAmozeshi_Service:SarFaslAmozeshiService,
    private DorehAmoozeshi_Service:DorehAmoozeshiService,
    private Skill_Service:SkillService
  ) { }

  ngOnInit() {

    this.AddNewPerson=new FormGroup({

      id:new FormControl(),
      fname:new FormControl(null,Validators.required),
      lname:new FormControl(null,Validators.required),
      sex:new FormControl("0"),
      shomareh_bimeh:new FormControl(),
      ProvinceId:new FormControl("0"),
      mahal_tavalod:new FormControl("0"),
      tedadFarzandan:new FormControl(),
      codeMeli:new FormControl(null),
      name_Hamsar:new FormControl(),
      name_Pedar:new FormControl(),
      shoghleh_Pedar:new FormControl(),
      codeMeli_Hamsar:new FormControl(null),
      shomareh_Shenasnameh:new FormControl(),
      shomareh_Shenasnameh_Seri:new FormControl(),
      shomareh_hamrah_Hamsar:new FormControl('',Validators.pattern('^[0-9]{10}$')),
      shomareh_Hamreh:new FormControl('',Validators.pattern('^[0-9]{10}$')),
      email:new FormControl('',Validators.email),
      tahsilat_Hamsar:new FormControl("0"),
      vaziat_Nazam_Vazifeh:new FormControl("0"),
      vaziat_Nazam_Vazifeh_Dsc:new FormControl(),
      vaziat_startDate:new FormControl(),
      vaziat_endDate:new FormControl(),
      vaziat_Tahol:new FormControl("0"),
      sabegh:new FormControl("0"),
      tarikh_Tavalod_Hamsar:new FormControl(),
      tarikh_Tavalod:new FormControl(),
      maskan:new FormControl("0"),
      address_Manzel:new FormControl(),
      tel:new FormControl(),
      codeposti:new FormControl(),
      shoghleh_Hamsar:new FormControl(),
      codemeli_Image1:new FormControl(),
      codemeli_Image2:new FormControl(),
      shenasNameh_Image1:new FormControl(),
      shenasNameh_Image2:new FormControl(),
      shenasNameh_Image3:new FormControl(),
      kartPayan_Khadamt_Image:new FormControl(),
      form_soe_Pishineh_Image:new FormControl(),
      ax_Personeli_Image:new FormControl(),
      ax_Personeli_Image2:new FormControl(),
      tarikh_Eshtekhdam:new FormControl(),
      almat_Ekhtesari:new FormControl(null,Validators.required),
      field_activity_id:new FormControl("0"),
      semat_id:new FormControl("0"),
    })

    this.Form_List_Hasilat_Record=new FormGroup({

      id:new FormControl(),
      date_starrt:new FormControl(null,Validators.required),
      date_end:new FormControl(null,Validators.required),
      degree:new FormControl(null,Validators.required),
      reshteh:new FormControl(null,Validators.required),
      grayesh:new FormControl(null,Validators.required),
      uni:new FormControl(null,Validators.required),
      moadel:new FormControl(null,Validators.required),
    })

    this.Form_List_kari_Record=new FormGroup({

      id:new FormControl(),
      date_starrt:new FormControl(null,Validators.required),
      date_end:new FormControl(null,Validators.required),
      companyName:new FormControl(null,Validators.required),
      type:new FormControl(null,Validators.required),
      semat:new FormControl(null,Validators.required),
      leave:new FormControl(null,Validators.required),
      tel:new FormControl(null,Validators.required),
      address:new FormControl(null,Validators.required),
    })

    this.Form_List_Amoozeshi_Record=new FormGroup({

      id:new FormControl(),
      date_starrt:new FormControl(null,Validators.required),
      date_end:new FormControl(null,Validators.required),
      sarFaslAmozeshi_id:new FormControl("0",Validators.required),
      dorehAmoozeshi_id:new FormControl("0",Validators.required),
      modat:new FormControl(null,Validators.required),
      bargozarKonnadeh:new FormControl(null,Validators.required),
    })

    this.Form_List_Skill_Record=new FormGroup({

      id:new FormControl(),
      skill:new FormControl("0",Validators.required),
      percent:new FormControl(null,Validators.required),
    })

    this.Form_List_Tahghighat_Record=new FormGroup({

      id:new FormControl(),
      title:new FormControl(null,Validators.required),
      tarikh:new FormControl(null,Validators.required),
      nasher:new FormControl(null,Validators.required),
      link:new FormControl(null,Validators.required),
    })


    this.Form_List_Document_Record=new FormGroup({

      id:new FormControl(),
      grpDoc_id:new FormControl("0",Validators.required),
      tlDoc_id:new FormControl("0",Validators.required),
      shomareh:new FormControl(null,Validators.required),
      taminKonandeh:new FormControl(null,Validators.required),
    })

    this.Nav_Service.CheckValidPage(39).subscribe(
      data=>{
        this.Read_Service_Province("")
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }


  //#region  Form Add

  AddNewPerson:FormGroup;

  get_Form_id(){
    return this.AddNewPerson.get('id') as FormControl;
  }

  get_Form_fname(){
    return this.AddNewPerson.get('fname') as FormControl;
  }

  get_Form_lname(){
    return this.AddNewPerson.get('lname') as FormControl;
  }

  get_Form_Sex(){
    return this.AddNewPerson.get('sex') as FormControl;
  }

  get_Form_sabegh(){
    return this.AddNewPerson.get('sabegh') as FormControl;
  }

  get_Form_shomareh_bimeh(){
    return this.AddNewPerson.get('shomareh_bimeh') as FormControl;
  }

  get_Form_ProvinceId(){
    return this.AddNewPerson.get('ProvinceId') as FormControl;
  }

  get_Form_mahal_tavalod(){
    return this.AddNewPerson.get('mahal_tavalod') as FormControl;
  }
  get_Form_codeMeli(){
    return this.AddNewPerson.get('codeMeli') as FormControl;
  }
  get_Form_name_Hamsar(){
    return this.AddNewPerson.get('name_Hamsar') as FormControl;
  }
  get_Form_name_Pedar(){
    return this.AddNewPerson.get('name_Pedar') as FormControl;
  }
  get_Form_tedadFarzandan(){
    return this.AddNewPerson.get('tedadFarzandan') as FormControl;
  }
  get_Form_shoghleh_Pedar(){
    return this.AddNewPerson.get('shoghleh_Pedar') as FormControl;
  }
  get_Form_codeMeli_Hamsar(){
    return this.AddNewPerson.get('codeMeli_Hamsar') as FormControl;
  }
  get_Form_shomareh_Shenasnameh(){
    return this.AddNewPerson.get('shomareh_Shenasnameh') as FormControl;
  }
  get_Form_shomareh_Shenasnameh_Seri(){
    return this.AddNewPerson.get('shomareh_Shenasnameh_Seri') as FormControl;
  }
  get_Form_shomareh_hamrah_Hamsar(){
    return this.AddNewPerson.get('shomareh_hamrah_Hamsar') as FormControl;
  }
  get_Form_shomareh_Hamreh(){
    return this.AddNewPerson.get('shomareh_Hamreh') as FormControl;
  }
  get_Form_email(){
    return this.AddNewPerson.get('email') as FormControl;
  }
  get_Form_tahsilat_Hamsar(){
    return this.AddNewPerson.get('tahsilat_Hamsar') as FormControl;
  }
  get_Form_vaziat_Nazam_Vazifeh(){
    return this.AddNewPerson.get('vaziat_Nazam_Vazifeh') as FormControl;
  }
  get_Form_vaziat_Nazam_Vazifeh_Dsc(){
    return this.AddNewPerson.get('vaziat_Nazam_Vazifeh_Dsc') as FormControl;
  }
  get_Form_vaziat_Tahol(){
    return this.AddNewPerson.get('vaziat_Tahol') as FormControl;
  }
  get_Form_vaziat_startDate(){
    return this.AddNewPerson.get('vaziat_startDate') as FormControl;
  }
  get_Form_vaziat_endDate(){
    return this.AddNewPerson.get('vaziat_endDate') as FormControl;
  }
  get_Form_tarikh_Tavalod_Hamsar(){
    return this.AddNewPerson.get('tarikh_Tavalod_Hamsar') as FormControl;
  }
  get_Form_tarikh_Tavalod(){
    return this.AddNewPerson.get('tarikh_Tavalod') as FormControl;
  }
  get_Form_maskan(){
    return this.AddNewPerson.get('maskan') as FormControl;
  }
  get_Form_address_Manzel(){
    return this.AddNewPerson.get('address_Manzel') as FormControl;
  }
  get_Form_shoghleh_Hamsar(){
    return this.AddNewPerson.get('shoghleh_Hamsar') as FormControl;
  }
  get_Form_codeposti(){
    return this.AddNewPerson.get('codeposti') as FormControl;
  }
  get_Form_tel(){
    return this.AddNewPerson.get('tel') as FormControl;
  }
  get_Form_tarikh_Eshtekhdam(){
    return this.AddNewPerson.get('tarikh_Eshtekhdam') as FormControl;
  }
  get_Form_almat_Ekhtesari(){
    return this.AddNewPerson.get('almat_Ekhtesari') as FormControl;
  }
  get_Form_field_activity_id(){
    return this.AddNewPerson.get('field_activity_id') as FormControl;
  }
  get_Form_semat_id(){
    return this.AddNewPerson.get('semat_id') as FormControl;
  }

  //#endregion


  //#region Province

  DataList_Province:Array<General_Interface>=[]
  DataList_City:Array<General_Interface>=[]

  Read_Service_Province(id:string){
    this.province_Service.GetRecord(id).subscribe(
      data=>{
        if(id=="")
        {
          this.DataList_Province=data
          this.ReadData_Semat()

        }
        else{
          this.DataList_City=data
        }
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  ProvinceChange(){
    if(this.get_Form_ProvinceId().value=="0")
    {
      this.DataList_City=[]
    }
    else{
      this.Read_Service_Province(this.get_Form_ProvinceId().value)
    }
  }


  //#endregion



  //#region جدول های شکسن اول

  Person_shomareh_hamrah_Hamsar_Array:Array<General_Interface>=[]
  OnAdd_shomareh_hamrah_Hamsar(){

    var Exited:boolean=false
    for  (let item of this.Person_shomareh_hamrah_Hamsar_Array)
    {
      if(item.title==this.get_Form_shomareh_hamrah_Hamsar().value)
      {
        Exited=true;
        break
      }
    }

    if(this.Person_shomareh_hamrah_Hamsar_Array.length==3)
    {
      this.Alertify_Service.ErrorMessage("امکان ثبت بیش از 3 شماره همراه نیست!")
    }
    else if(Exited)
    {
      this.Alertify_Service.ErrorMessage("شماره همراه در لیست وجود دارد")
    }
    else
    {
      var temp:General_Interface=Empty_General_Interface()
      temp.title=this.get_Form_shomareh_hamrah_Hamsar().value
      this.Person_shomareh_hamrah_Hamsar_Array.push(temp)


      this.get_Form_shomareh_hamrah_Hamsar().setValue("")
      this.Alertify_Service.SuccessMessage("شماره همراه همسر در لیست ثبت شد")
    }
  }

  Person_shomareh_hamrah_Hamsar_Delete(id){
    this.Person_shomareh_hamrah_Hamsar_Array.splice(id,1)
    this.Alertify_Service.SuccessMessage("شماره همراه همسر از لیست حذف شد")
  }
////////////////////

  Person_shomareh_Hamreh_Array:Array<General_Interface>=[]
  OnAdd_shomareh_Hamreh(){

    var Exited:boolean=false
    for  (let item of this.Person_shomareh_Hamreh_Array)
    {
      if(item.title==this.get_Form_shomareh_Hamreh().value)
      {
        Exited=true;
        break
      }
    }

    if(this.Person_shomareh_Hamreh_Array.length==3)
    {
      this.Alertify_Service.ErrorMessage("امکان ثبت بیش از 3 شماره همراه نیست!")
    }
    else if(Exited)
    {
      this.Alertify_Service.ErrorMessage("شماره همراه در لیست وجود دارد")
    }
    else
    {
      var temp:General_Interface=Empty_General_Interface()
      temp.title=this.get_Form_shomareh_Hamreh().value
      this.Person_shomareh_Hamreh_Array.push(temp)


      this.get_Form_shomareh_Hamreh().setValue("")
      this.Alertify_Service.SuccessMessage("شماره همراه در لیست ثبت شد")
    }
  }

  Person_shomareh_Hamreh_Delete(id){
    this.Person_shomareh_Hamreh_Array.splice(id,1)
    this.Alertify_Service.SuccessMessage("شماره همراه از لیست حذف شد")
  }
/////////////////////

  Person_email_Array:Array<General_Interface>=[]
  OnAdd_email(){

    var Exited:boolean=false
    for  (let item of this.Person_email_Array)
    {
      if(item.title==this.get_Form_email().value)
      {
        Exited=true;
        break
      }
    }

    if(this.Person_email_Array.length==3)
    {
      this.Alertify_Service.ErrorMessage("امکان ثبت بیش از 3 ایمیل نیست!")
    }
    else if(Exited)
    {
      this.Alertify_Service.ErrorMessage("ایمیل در لیست وجود دارد")
    }
    else
    {
      var temp:General_Interface=Empty_General_Interface()
      temp.title=this.get_Form_email().value
      this.Person_email_Array.push(temp)


      this.get_Form_email().setValue("")
      this.Alertify_Service.SuccessMessage("ایمیل در لیست ثبت شد")
    }
  }

  Person_email_Delete(id){
    this.Person_email_Array.splice(id,1)
    this.Alertify_Service.SuccessMessage("ایمیل از لیست حذف شد")
  }
//////////////////////
  Person_address_Manzel_Array:Array<General_Interface>=[]
  OnAdd_address_Manzel(){

    var Exited:boolean=false
    for  (let item of this.Person_address_Manzel_Array)
    {
      if(item.title==this.get_Form_address_Manzel().value)
      {
        Exited=true;
        break
      }
    }

    if(this.Person_address_Manzel_Array.length==3)
    {
      this.Alertify_Service.ErrorMessage("امکان ثبت بیش از 3 آدرس منزل فعلی نیست!")
    }
    else if(Exited)
    {
      this.Alertify_Service.ErrorMessage("آدرس منزل فعلی در لیست وجود دارد")
    }
    else
    {
      var temp:General_Interface=Empty_General_Interface()
      temp.title=this.get_Form_address_Manzel().value
      this.Person_address_Manzel_Array.push(temp)


      this.get_Form_address_Manzel().setValue("")
      this.Alertify_Service.SuccessMessage("آدرس منزل فعلی در لیست ثبت شد")
    }
  }

  Person_address_Manzel_Delete(id){
    this.Person_address_Manzel_Array.splice(id,1)
    this.Alertify_Service.SuccessMessage("آدرس منزل فعلی از لیست حذف شد")
  }
///////////////////////////

Person_codeposti_Array:Array<General_Interface>=[]
OnAdd_codeposti(){

  var Exited:boolean=false
  for  (let item of this.Person_codeposti_Array)
  {
    if(item.title==this.get_Form_codeposti().value)
    {
      Exited=true;
      break
    }
  }

  if(this.Person_codeposti_Array.length==3)
  {
    this.Alertify_Service.ErrorMessage("امکان ثبت بیش از 3 کدپستی نیست!")
  }
  else if(Exited)
  {
    this.Alertify_Service.ErrorMessage("کدپستی در لیست وجود دارد")
  }
  else
  {
    var temp:General_Interface=Empty_General_Interface()
    temp.title=this.get_Form_codeposti().value
    this.Person_codeposti_Array.push(temp)


    this.get_Form_codeposti().setValue("")
    this.Alertify_Service.SuccessMessage("کدپستی در لیست ثبت شد")
  }
}

Person_codeposti_Delete(id){
  this.Person_codeposti_Array.splice(id,1)
  this.Alertify_Service.SuccessMessage("کدپستی از لیست حذف شد")
}

/////////////////////

Person_tel_Array:Array<General_Interface>=[]
OnAdd_tel(){

  var Exited:boolean=false
  for  (let item of this.Person_tel_Array)
  {
    if(item.title==this.get_Form_tel().value)
    {
      Exited=true;
      break
    }
  }

  if(this.Person_tel_Array.length==3)
  {
    this.Alertify_Service.ErrorMessage("امکان ثبت بیش از 3 تلفن نیست!")
  }
  else if(Exited)
  {
    this.Alertify_Service.ErrorMessage("تلفن در لیست وجود دارد")
  }
  else
  {
    var temp:General_Interface=Empty_General_Interface()
    temp.title=this.get_Form_tel().value
    this.Person_tel_Array.push(temp)


    this.get_Form_tel().setValue("")
    this.Alertify_Service.SuccessMessage("تلفن در لیست ثبت شد")
  }
}

Person_tel_Delete(id){
  this.Person_tel_Array.splice(id,1)
  this.Alertify_Service.SuccessMessage("تلفن از لیست حذف شد")
}


  //#endregion

  //#region سمت

  DataList_Semat:Array<General_Interface>=[]
  ReadData_Semat(){
    this.Semat_Service.GetActiveList().subscribe(
      data=>{
        this.DataList_Semat=data
        this.ReadData_SarFaslAmozeshi()
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  //#endregion


  //#region آپلود عکس ها

  modalRef_Image: any;
  ModalimageUrl:String=''
  openModal(template: TemplateRef<any>,imageUrl:String) {
    this.ModalimageUrl=imageUrl
    this.modalRef_Image = this.modalService.show(template);
  }


  InProccessing_codemeli_Image1:boolean=false
  uploadcodemeli_Image1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_codemeli_Image1=true

    this.Person_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_codemeli_Image1=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.Add_Record_Persone.codemeli_Image1=data['filename']
        }
      }
    )

  }

  Remove_uploadcodemeli_Image1(){
    this.Add_Record_Persone.codemeli_Image1=''
  }


  InProccessing_codemeli_Image2:boolean=false
  uploadcodemeli_Image2(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_codemeli_Image2=true

    this.Person_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_codemeli_Image2=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.Add_Record_Persone.codemeli_Image2=data['filename']
        }
      }
    )

  }

  Remove_uploadcodemeli_Image2(){
    this.Add_Record_Persone.codemeli_Image2=''
  }


  InProccessing_shenasNameh_Image1:boolean=false
  uploadshenasNameh_Image1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_shenasNameh_Image1=true

    this.Person_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_shenasNameh_Image1=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.Add_Record_Persone.shenasNameh_Image1=data['filename']
        }
      }
    )

  }

  Remove_uploadshenasNameh_Image1(){
    this.Add_Record_Persone.shenasNameh_Image1=''
  }


  InProccessing_shenasNameh_Image2:boolean=false
  uploadshenasNameh_Image2(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_shenasNameh_Image2=true

    this.Person_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_shenasNameh_Image2=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.Add_Record_Persone.shenasNameh_Image2=data['filename']
        }
      }
    )

  }

  Remove_uploadshenasNameh_Image2(){
    this.Add_Record_Persone.shenasNameh_Image2=''
  }



  InProccessing_shenasNameh_Image3:boolean=false
  uploadshenasNameh_Image3(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_shenasNameh_Image3=true

    this.Person_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_shenasNameh_Image3=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.Add_Record_Persone.shenasNameh_Image3=data['filename']
        }
      }
    )

  }

  Remove_uploadshenasNameh_Image3(){
    this.Add_Record_Persone.shenasNameh_Image3=''
  }

  InProccessing_kartPayan_Khadamt_Image:boolean=false
  uploadkartPayan_Khadamt_Image(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_kartPayan_Khadamt_Image=true

    this.Person_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_kartPayan_Khadamt_Image=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.Add_Record_Persone.kartPayan_Khadamt_Image=data['filename']
        }
      }
    )

  }

  Remove_uploadkartPayan_Khadamt_Image(){
    this.Add_Record_Persone.kartPayan_Khadamt_Image=''
  }


  InProccessing_form_soe_Pishineh_Image:boolean=false
  uploadform_soe_Pishineh_Image(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_form_soe_Pishineh_Image=true

    this.Person_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_form_soe_Pishineh_Image=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.Add_Record_Persone.form_soe_Pishineh_Image=data['filename']
        }
      }
    )

  }

  Remove_uploadform_soe_Pishineh_Image(){
    this.Add_Record_Persone.form_soe_Pishineh_Image=''
  }

  InProccessing_ax_Personeli_Image:boolean=false
  uploadax_Personeli_Image(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();



    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_ax_Personeli_Image=true

    this.Person_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_ax_Personeli_Image=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.Add_Record_Persone.ax_Personeli_Image=data['filename']
        }
      }
    )

  }

  Remove_uploadax_Personeli_Image(){
    this.Add_Record_Persone.ax_Personeli_Image=''
  }

  InProccessing_ax_Personeli_Image2:boolean=false
  uploadax_Personeli_Image2(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();



    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_ax_Personeli_Image2=true

    this.Person_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_ax_Personeli_Image2=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.Add_Record_Persone.ax_Personeli_Image2=data['filename']
        }
      }
    )

  }

  Remove_uploadax_Personeli_Image2(){
    this.Add_Record_Persone.ax_Personeli_Image2=''
  }


  InProccessing_ax_Sign_Image:boolean=false
  uploadax_Sign_Image(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();



    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_ax_Sign_Image=true

    this.Person_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_ax_Sign_Image=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.Add_Record_Persone.sign_image=data['filename']
        }
      }
    )

  }

  Remove_uploadax_Sign_Image(){
    this.Add_Record_Persone.sign_image=''
  }

  InProccessing_form_reserve_mosahebeh_Image:boolean=false
  uploadform_reserve_mosahebeh_Image(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_form_reserve_mosahebeh_Image=true

    this.Person_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_form_reserve_mosahebeh_Image=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.Add_Record_Persone.form_reserve_mosahebeh_Image=data['filename']
        }
      }
    )

  }

  Remove_uploadform_reserve_mosahebeh_Image(){
    this.Add_Record_Persone.form_reserve_mosahebeh_Image=''
  }


  //#endregion


  InProccessing:boolean=false

  SubmitAddNewPerson(){

    if(this.get_Form_Sex().value=="0")
    {
      this.Alertify_Service.ErrorMessage("جنسیت را انتخاب کنید")
    }
    else if(this.get_Form_mahal_tavalod().value=="0")
    {
      this.Alertify_Service.ErrorMessage("محل صدور را انتخاب کنید")
    }
    else{

      for(let item of this.Person_shomareh_hamrah_Hamsar_Array)
      {
        this.Add_Record_Persone.shomareh_hamrah_Hamsar=this.Add_Record_Persone.shomareh_hamrah_Hamsar+","+item.title
      }

      for(let item of this.Person_shomareh_Hamreh_Array)
      {
        this.Add_Record_Persone.shomareh_Hamreh=this.Add_Record_Persone.shomareh_Hamreh+","+item.title
      }

      for(let item of this.Person_email_Array)
      {
        this.Add_Record_Persone.email=this.Add_Record_Persone.email+","+item.title
      }

      for(let item of this.Person_address_Manzel_Array)
      {
        this.Add_Record_Persone.address_Manzel=this.Add_Record_Persone.address_Manzel+","+item.title
      }

      for(let item of this.Person_tel_Array)
      {
        this.Add_Record_Persone.tel=this.Add_Record_Persone.tel+","+item.title
      }

      for(let item of this.Person_codeposti_Array)
      {
        this.Add_Record_Persone.codeposti=this.Add_Record_Persone.codeposti+","+item.title
      }

      this.Add_Record_Persone.fname=this.get_Form_fname().value
      this.Add_Record_Persone.lname=this.get_Form_lname().value
      this.Add_Record_Persone.shomareh_bimeh=this.get_Form_shomareh_bimeh().value
      this.Add_Record_Persone.mahal_tavalod=Number(this.get_Form_mahal_tavalod().value)
      this.Add_Record_Persone.codeMeli=Number(this.get_Form_codeMeli().value)
      this.Add_Record_Persone.name_Hamsar=this.get_Form_name_Hamsar().value
      this.Add_Record_Persone.name_Pedar=this.get_Form_name_Pedar().value
      this.Add_Record_Persone.shoghleh_Pedar=this.get_Form_shoghleh_Pedar().value
      this.Add_Record_Persone.codeMeli_Hamsar=Number(this.get_Form_codeMeli_Hamsar().value)
      this.Add_Record_Persone.shomareh_Shenasnameh=Number(this.get_Form_shomareh_Shenasnameh().value)
      this.Add_Record_Persone.tahsilat_Hamsar=Number(this.get_Form_tahsilat_Hamsar().value)
      this.Add_Record_Persone.vaziat_Nazam_Vazifeh=Number(this.get_Form_vaziat_Nazam_Vazifeh().value)
      this.Add_Record_Persone.vaziat_Nazam_Vazifeh_Dsc=this.get_Form_vaziat_Nazam_Vazifeh_Dsc().value
      this.Add_Record_Persone.vaziat_Tahol=Number(this.get_Form_vaziat_Tahol().value)
      this.Add_Record_Persone.tarikh_Tavalod_Hamsar=this.get_Form_tarikh_Tavalod_Hamsar().value
      this.Add_Record_Persone.tarikh_Tavalod=this.get_Form_tarikh_Tavalod().value
      this.Add_Record_Persone.maskan=Number(this.get_Form_maskan().value)
      this.Add_Record_Persone.shoghleh_Hamsar=this.get_Form_shoghleh_Hamsar().value
      this.Add_Record_Persone.tarikh_Eshtekhdam=this.get_Form_tarikh_Eshtekhdam().value
      this.Add_Record_Persone.almat_Ekhtesari=this.get_Form_almat_Ekhtesari().value
      this.Add_Record_Persone.field_activity_id=Number(this.get_Form_field_activity_id().value)
      this.Add_Record_Persone.semat_id=Number(this.get_Form_semat_id().value)
      this.Add_Record_Persone.sabegh=Number(this.get_Form_sabegh().value)
      this.Add_Record_Persone.shomareh_Shenasnameh_Seri=this.get_Form_shomareh_Shenasnameh_Seri().value

      if(this.get_Form_Sex().value=="1")
        this.Add_Record_Persone.sex=true
      else
        this.Add_Record_Persone.sex=false

      this.Add_Record_Persone.vaziat_startDate=this.get_Form_vaziat_startDate().value
      this.Add_Record_Persone.vaziat_endDate=this.get_Form_vaziat_endDate().value
      this.Add_Record_Persone.tedadFarzandan=Number(this.get_Form_tedadFarzandan().value)

      this.InProccessing=true
      this.Person_Service.AddPersone(
        this.Add_Record_Persone,
        this.Data_Kari_List,
        this.Data_Tahsilat_List,
        this.Data_Amoozeshi_List,
        this.Data_Skill_List,
        this.Data_Tahghighat_List,
        this.Data_Document_List
        ).subscribe(
        data=>{
          this.InProccessing=false
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

          this.AddNewPerson.reset()
          this.get_Form_ProvinceId().setValue("0")
          this.get_Form_mahal_tavalod().setValue("0")
          this.get_Form_tahsilat_Hamsar().setValue("0")
          this.get_Form_vaziat_Nazam_Vazifeh().setValue("0")
          this.get_Form_vaziat_Tahol().setValue("0")
          this.get_Form_maskan().setValue("0")
          this.get_Form_field_activity_id().setValue("0")
          this.get_Form_semat_id().setValue("0")
          this.get_Form_Sex().setValue("0")
          this.Person_shomareh_hamrah_Hamsar_Array=[]
          this.Person_shomareh_Hamreh_Array=[]
          this.Person_email_Array=[]
          this.Person_codeposti_Array=[]
          this.Person_address_Manzel_Array=[]
          this.Person_tel_Array=[]

          this.Data_Kari_List=[]
          this.Data_Tahsilat_List=[]
          this.Data_Amoozeshi_List=[]
          this.Data_Skill_List=[]
          this.Data_Tahghighat_List=[]
          this.Data_Document_List=[]



          this.Add_Record_Persone=Empty_Person_Interface()
        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )

    }

  }











//#region   General

DataList_SarFaslAmozeshi:Array<General_Interface>=[]
ReadData_SarFaslAmozeshi(){
  this.SarFaslAmozeshi_Service.GetActiveList().subscribe(
    data=>{
      this.DataList_SarFaslAmozeshi=data
      this.ReadData_Skill()
    },error=>{
      // AuthInterceptor owns authentication; feature errors must preserve credentials.

    }
  )
}

DataList_DorehAmoozeshi:Array<General_Interface>=[]

ReadData_DorehAmoozeshi(){
  this.DorehAmoozeshi_Service.GetActiveList(Number(this.get_Form_List_Amoozeshi_Record_sarFaslAmozeshi_id().value)).subscribe(
    data=>{
      this.DataList_DorehAmoozeshi=data

    },error=>{
      // AuthInterceptor owns authentication; feature errors must preserve credentials.

    }
  )
}

DataList_Skill:Array<General_Interface>=[]

ReadData_Skill(){
  this.Skill_Service.GetActiveList().subscribe(
    data=>{
      this.DataList_Skill=data
      this.ReadData_DocumentGroup()
    },error=>{
      // AuthInterceptor owns authentication; feature errors must preserve credentials.

    }
  )
}

DataList_DocumentGroup:Array<General_Interface>=[]
ReadData_DocumentGroup(){
  this.DocumentGroup_Service.GetActiveList().subscribe(
    data=>{
      this.DataList_DocumentGroup=data
      //this.ReadData_DocumentTitle()
    },error=>{
      // AuthInterceptor owns authentication; feature errors must preserve credentials.

    }
  )
}

DataList_DocumentTitle:Array<General_Interface>=[]
ReadData_DocumentTitle(){

  this.DocumentTitle_Service.GetActiveList(Number(this.get_Form_List_Document_Record_grpDoc_id().value)).subscribe(
    data=>{
      this.DataList_DocumentTitle=data
    },error=>{
      // AuthInterceptor owns authentication; feature errors must preserve credentials.

    }
  )
}

//#endregion



//#region تحصیلات
  Form_List_Hasilat_Record:FormGroup
  Data_Tahsilat_List:Array<Person_Tahsili_Interface>=[]


  get_Form_List_Hasilat_Record_id(){
    return this.Form_List_Hasilat_Record.get('id') as FormControl;
  }

  get_Form_List_Hasilat_Record_date_starrt(){
    return this.Form_List_Hasilat_Record.get('date_starrt') as FormControl;
  }

  get_Form_List_Hasilat_Record_date_end(){
    return this.Form_List_Hasilat_Record.get('date_end') as FormControl;
  }

  get_Form_List_Hasilat_Record_degree(){
    return this.Form_List_Hasilat_Record.get('degree') as FormControl;
  }

  get_Form_List_Hasilat_Record_reshteh(){
    return this.Form_List_Hasilat_Record.get('reshteh') as FormControl;
  }

  get_Form_List_Hasilat_Record_grayesh(){
    return this.Form_List_Hasilat_Record.get('grayesh') as FormControl;
  }

  get_Form_List_Hasilat_Record_uni(){
    return this.Form_List_Hasilat_Record.get('uni') as FormControl;
  }

  get_Form_List_Hasilat_Record_moadel(){
    return this.Form_List_Hasilat_Record.get('moadel') as FormControl;
  }

  ax_Hasilat_Image:string=''
  InProccessing_ax_Hasilat_Image:boolean=false
  uploadax_Hasilat_Image(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();


    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_ax_Hasilat_Image=true

    this.Person_Service.uploadFile(formData).subscribe(
      data=>{
        this.InProccessing_ax_Hasilat_Image=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("فایل آپلود شد")
          this.ax_Hasilat_Image=data['filename']
        }
      }
    )

  }

  Remove_uploadax_Hasilat_Image(){
    this.ax_Hasilat_Image=''
  }

  onSubmitTahsimla(){
    var temp:Person_Tahsili_Interface=Empty_Person_Tahsili_Interface();
    temp.id=0
    temp.date_starrt=this.get_Form_List_Hasilat_Record_date_starrt().value
    temp.date_end=this.get_Form_List_Hasilat_Record_date_end().value
    temp.degree=this.get_Form_List_Hasilat_Record_degree().value
    temp.reshteh=this.get_Form_List_Hasilat_Record_reshteh().value
    temp.grayesh=this.get_Form_List_Hasilat_Record_grayesh().value
    temp.uni=this.get_Form_List_Hasilat_Record_uni().value
    temp.moadel=this.get_Form_List_Hasilat_Record_moadel().value+""
    temp.image=this.ax_Hasilat_Image


    this.ax_Hasilat_Image=''
    this.Form_List_Hasilat_Record.reset()

    this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

    this.Data_Tahsilat_List.push(temp )
  }

  RemoveTahsimla(id)
  {
    this.Data_Tahsilat_List.splice(id,1)
    this.Alertify_Service.SuccessMessage("حذف شد")
  }

//#endregion



//#region کاری
Form_List_kari_Record:FormGroup
Data_Kari_List:Array<Person_Kari_Interface>=[]


get_Form_List_kari_Record_id(){
  return this.Form_List_kari_Record.get('id') as FormControl;
}

get_Form_List_kari_Record_date_starrt(){
  return this.Form_List_kari_Record.get('date_starrt') as FormControl;
}

get_Form_List_kari_Record_date_end(){
  return this.Form_List_kari_Record.get('date_end') as FormControl;
}

get_Form_List_kari_Record_companyName(){
  return this.Form_List_kari_Record.get('companyName') as FormControl;
}

get_Form_List_kari_Record_type(){
  return this.Form_List_kari_Record.get('type') as FormControl;
}

get_Form_List_kari_Record_semat(){
  return this.Form_List_kari_Record.get('semat') as FormControl;
}

get_Form_List_kari_Record_leave(){
  return this.Form_List_kari_Record.get('leave') as FormControl;
}

get_Form_List_kari_Record_tel(){
  return this.Form_List_kari_Record.get('tel') as FormControl;
}

get_Form_List_kari_Record_address(){
  return this.Form_List_kari_Record.get('address') as FormControl;
}



onSubmitkari(){
  var temp:Person_Kari_Interface=Empty_Person_Kari_Interface();
  temp.id=0
  temp.date_starrt=this.get_Form_List_kari_Record_date_starrt().value
  temp.date_end=this.get_Form_List_kari_Record_date_end().value
  temp.companyName=this.get_Form_List_kari_Record_companyName().value
  temp.type=this.get_Form_List_kari_Record_type().value
  temp.semat=this.get_Form_List_kari_Record_semat().value
  temp.leave=this.get_Form_List_kari_Record_leave().value
  temp.tel=this.get_Form_List_kari_Record_tel().value
  temp.address=this.get_Form_List_kari_Record_address().value

  this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

  this.Data_Kari_List.push(temp )
}

RemoveKari(id)
{
  this.Data_Kari_List.splice(id,1)
  this.Alertify_Service.SuccessMessage("حذف شد")
}

//#endregion



//#region آموزشی
Form_List_Amoozeshi_Record:FormGroup
Data_Amoozeshi_List:Array<Person_Amozesh_Interface>=[]


get_Form_List_Amoozeshi_Record_id(){
  return this.Form_List_Amoozeshi_Record.get('id') as FormControl;
}

get_Form_List_Amoozeshi_Record_date_starrt(){
  return this.Form_List_Amoozeshi_Record.get('date_starrt') as FormControl;
}

get_Form_List_Amoozeshi_Record_date_end(){
  return this.Form_List_Amoozeshi_Record.get('date_end') as FormControl;
}

get_Form_List_Amoozeshi_Record_sarFaslAmozeshi_id(){
  return this.Form_List_Amoozeshi_Record.get('sarFaslAmozeshi_id') as FormControl;
}

get_Form_List_Amoozeshi_Record_dorehAmoozeshi_id(){
  return this.Form_List_Amoozeshi_Record.get('dorehAmoozeshi_id') as FormControl;
}

get_Form_List_Amoozeshi_Record_modat(){
  return this.Form_List_Amoozeshi_Record.get('modat') as FormControl;
}

get_Form_List_Amoozeshi_Record_bargozarKonnadeh(){
  return this.Form_List_Amoozeshi_Record.get('bargozarKonnadeh') as FormControl;
}


ax_Amoozeshi_Image:string=''
InProccessing_ax_Amoozeshi_Image:boolean=false
uploadax_Amoozeshi_Image(files) {
  if (files.length === 0)
    return;

  const formData = new FormData();


  for (const file of files) {
    formData.append(file.name, file);
  }

  this.InProccessing_ax_Amoozeshi_Image=true

  this.Person_Service.uploadFile(formData).subscribe(
    data=>{
      this.InProccessing_ax_Amoozeshi_Image=false
      if(data['id']==0)
      {
        this.Alertify_Service.ErrorMessage(data['filename'])
      }
      else{
        this.Alertify_Service.SuccessMessage("فایل آپلود شد")
        this.ax_Amoozeshi_Image=data['filename']
      }
    }
  )

}

Remove_uploadax_Amoozeshi_Image(){
  this.ax_Amoozeshi_Image=''
}

onSubmitAmozeshi(){

  if(this.get_Form_List_Amoozeshi_Record_dorehAmoozeshi_id().value=="0")
  {
    this.Alertify_Service.ErrorMessage("عنوان دوره آموزشی را انتخاب نمائید")
  }
  else if(this.get_Form_List_Amoozeshi_Record_sarFaslAmozeshi_id().value=="0")
  {
    this.Alertify_Service.ErrorMessage("سرفصل آموزشی را انتخاب نمائید")
  }
  else{
    var temp:Person_Amozesh_Interface=Empty_Person_Amozesh_Interface();
    temp.id=0
    temp.date_starrt=this.get_Form_List_Amoozeshi_Record_date_starrt().value
    temp.date_end=this.get_Form_List_Amoozeshi_Record_date_end().value
    temp.sarFaslAmozeshi_id=Number(this.get_Form_List_Amoozeshi_Record_sarFaslAmozeshi_id().value)
    temp.sarFaslAmozeshiTitle=this.find_sarFaslAmozeshi( temp.sarFaslAmozeshi_id)

    temp.dorehAmoozeshi_id=Number(this.get_Form_List_Amoozeshi_Record_dorehAmoozeshi_id().value)
    temp.dorehAmoozeshiTitle=this.find_dorehAmoozeshi( temp.dorehAmoozeshi_id)

    temp.modat=Number(this.get_Form_List_Amoozeshi_Record_modat().value)
    temp.bargozarKonnadeh=this.get_Form_List_Amoozeshi_Record_bargozarKonnadeh().value
    temp.image=this.ax_Amoozeshi_Image


    this.ax_Amoozeshi_Image=''
    this.Form_List_Amoozeshi_Record.reset()
    this.get_Form_List_Amoozeshi_Record_sarFaslAmozeshi_id().setValue("0")
    this.get_Form_List_Amoozeshi_Record_dorehAmoozeshi_id().setValue("0")

    this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

    this.Data_Amoozeshi_List.push(temp )
  }
}


find_sarFaslAmozeshi(id){
  for(let item of this.DataList_SarFaslAmozeshi)
  {
    if(item.id==id)
    {
      return item.title
    }
  }
}

find_dorehAmoozeshi(id){
  for(let item of this.DataList_DorehAmoozeshi)
  {
    if(item.id==id)
    {
      return item.title
    }
  }
}


RemoveAmozeshi(id)
{
  this.Data_Amoozeshi_List.splice(id,1)
  this.Alertify_Service.SuccessMessage("حذف شد")
}

//#endregion


//#region مهارت
Form_List_Skill_Record:FormGroup
Data_Skill_List:Array<Person_Skill_Interface>=[]


get_Form_List_Skill_Record_id(){
  return this.Form_List_Skill_Record.get('id') as FormControl;
}

get_Form_List_Skill_Record_skill(){
  return this.Form_List_Skill_Record.get('skill') as FormControl;
}

get_Form_List_Skill_Record_percent(){
  return this.Form_List_Skill_Record.get('percent') as FormControl;
}


onSubmitSkill(){

  if(this.get_Form_List_Skill_Record_skill().value=="0")
  {
    this.Alertify_Service.ErrorMessage("مهارت را انتخاب نمائید")
  }
  else if(Number(this.get_Form_List_Skill_Record_percent().value)>100 || Number(this.get_Form_List_Skill_Record_percent().value)<0)
  {
    this.Alertify_Service.ErrorMessage("درصد را صحیح وارد نشده است")
  }
  else{
    var temp:Person_Skill_Interface=Empty_Person_Skill_Interface();
    temp.id=0
    temp.skill_id=Number(this.get_Form_List_Skill_Record_skill().value)
    temp.skillTitle=this.find_Skill(temp.skill_id)
    temp.percennt= Number(this.get_Form_List_Skill_Record_percent().value)


    this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

    this.Form_List_Skill_Record.reset()

    this.get_Form_List_Skill_Record_skill().setValue("0")

    this.Data_Skill_List.push(temp )
  }
}

find_Skill(id){
  for(let item of this.DataList_Skill)
  {
    if(item.id==id)
    {
      return item.title
    }
  }
}

RemoveSkill(id)
{
  this.Data_Skill_List.splice(id,1)
  this.Alertify_Service.SuccessMessage("حذف شد")
}

//#endregion



//#region تحقیقات
Form_List_Tahghighat_Record:FormGroup
Data_Tahghighat_List:Array<Person_Tahghigh_Interface>=[]


get_Form_List_Tahghighat_Record_id(){
  return this.Form_List_Tahghighat_Record.get('id') as FormControl;
}

get_Form_List_Tahghighat_Record_title(){
  return this.Form_List_Tahghighat_Record.get('title') as FormControl;
}
get_Form_List_Tahghighat_Record_tarikh(){
  return this.Form_List_Tahghighat_Record.get('tarikh') as FormControl;
}
get_Form_List_Tahghighat_Record_nasher(){
  return this.Form_List_Tahghighat_Record.get('nasher') as FormControl;
}
get_Form_List_Tahghighat_Record_link(){
  return this.Form_List_Tahghighat_Record.get('link') as FormControl;
}


onSubmitTahghighat(){

  var temp:Person_Tahghigh_Interface=Empty_Person_Tahghigh_Interface();
  temp.id=0
  temp.title= this.get_Form_List_Tahghighat_Record_title().value
  temp.tarikh= this.get_Form_List_Tahghighat_Record_tarikh().value
  temp.nasher= this.get_Form_List_Tahghighat_Record_nasher().value
  temp.link= this.get_Form_List_Tahghighat_Record_link().value

  this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

  this.Form_List_Tahghighat_Record.reset()
  this.Data_Tahghighat_List.push(temp )
}

RemoveTahghighat(id)
{
  this.Data_Tahghighat_List.splice(id,1)
  this.Alertify_Service.SuccessMessage("حذف شد")
}

//#endregion


//#region مهارت
Form_List_Document_Record:FormGroup
Data_Document_List:Array<Person_Document_Interface>=[]


get_Form_List_Document_Record_id(){
  return this.Form_List_Document_Record.get('id') as FormControl;
}

get_Form_List_Document_Record_grpDoc_id(){
  return this.Form_List_Document_Record.get('grpDoc_id') as FormControl;
}
get_Form_List_Document_Record_tlDoc_id(){
  return this.Form_List_Document_Record.get('tlDoc_id') as FormControl;
}
get_Form_List_Document_Record_shomareh(){
  return this.Form_List_Document_Record.get('shomareh') as FormControl;
}
get_Form_List_Document_Record_taminKonandeh(){
  return this.Form_List_Document_Record.get('taminKonandeh') as FormControl;
}




onSubmitDocument(){

  if(this.get_Form_List_Document_Record_grpDoc_id().value=="0")
  {
    this.Alertify_Service.ErrorMessage("گروه اسناد را انتخاب نمائید")
  }
  else  if(this.get_Form_List_Document_Record_tlDoc_id().value=="0")
  {
    this.Alertify_Service.ErrorMessage("عنوان سند را انتخاب نمائید")
  }
  else{
    var temp:Person_Document_Interface=Empty_Person_Document_Interface();
    temp.id=0
    temp.grpDoc_id=Number(this.get_Form_List_Document_Record_grpDoc_id().value)
    temp.grpDocTitle=this.find_DocumentGroup(temp.grpDoc_id)

    temp.tlDoc_id=Number(this.get_Form_List_Document_Record_tlDoc_id().value)
    temp.tlDocTitle=this.find_DocumentTitle(temp.tlDoc_id)


    temp.shomareh= this.get_Form_List_Document_Record_shomareh().value
    temp.taminKonandeh= this.get_Form_List_Document_Record_taminKonandeh().value



    this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

    this.Form_List_Document_Record.reset()

    this.get_Form_List_Document_Record_grpDoc_id().setValue("0")
    this.get_Form_List_Document_Record_tlDoc_id().setValue("0")

    this.Data_Document_List.push(temp )
  }
}

find_DocumentGroup(id){
  for(let item of this.DataList_DocumentGroup)
  {
    if(item.id==id)
    {
      return item.title
    }
  }
}

find_DocumentTitle(id){
  for(let item of this.DataList_DocumentTitle)
  {
    if(item.id==id)
    {
      return item.title
    }
  }
}

RemoveDocument(id)
{
  this.Data_Document_List.splice(id,1)
  this.Alertify_Service.SuccessMessage("حذف شد")
}

//#endregion






}
